import api from '@/api';
import makeSorter from '@/lib/makeSorter';
import { regexpSearch } from '@/lib/searchFns';
import ___ from '../constants';
import { result } from 'lodash';
import { matchesExactFields, matchesIncludeFields, subtractFields } from '../shared/searchUtilites';
import { message } from 'antd';


const dateColumns = [
    'est_arrival_date',
]

const initialState = {
    currentEditRow: null,
    currentEditHeader: null,
    detailLines: null,
    originalOrders: [],
    filteredOrders: [],
    loading: false,
    searchLoading: false,
    columns: [],
    filteredSource: [],
    searchedSource: [],
    sortOrder: false,
    sortField: false,
    sorting: [],
    filters: [],
    modalOpen: false,
    //pictureAttachments: null,
    picturesLoading: false,
    msgAttachments: [],
    _msgObjects: [],
    attachmentErrors: [],
    inventoryResults: [],
    inventoryResultsExact: [],
    inventorySearchLoading: false,
};

export const types = {
    SET_STATE: 'OUTGOING/SET_STATE',
    CLEAR_SEARCH: 'OUTGOING/CLEAR_SEARCH'
};

export const reducers = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_STATE:
            return { ...state, ...action.data };

        case types.CLEAR_SEARCH:
            return {
                ...state,
                inventoryResults: [],
                inventoryResultsExact: [],
                inventorySearchValue: '',
                inventorySearchLoading: false,
            };

        default:
            return state;
    }
};




export const actions = {
    setState: (data) => ({ type: types.SET_STATE, data }),

    clearInventorySearch: () => ({
        type: types.CLEAR_SEARCH,
    }),

    setCurrentEditRow: (row) => async (dispatch, getState) => {
        console.log('[Outgoing.redux.js] setCurrentEditRow');
        console.log(row);
        dispatch({
            type: types.SET_STATE,
            data: {
                currentEditRow: row,
            },
        });
    },

    getShippingMethods: () => async (dispatch) => {
        console.log('[Outgoing.redux] getShippingMethods');
        dispatch(actions.setState({ loading: true }));

        try {
            let [shippingMethods] = await Promise.all([
                api.get('/warehouse/shipping-methods'),
            ]);

            //console.log('shippingMethods');
            //console.log(shippingMethods);
            dispatch(actions.setState({
                loading: false,
                shippingMethods: shippingMethods.shippingMethods,
            }));
        } catch (err) {
            console.error(err);
        }
    },

    getOutgoingOrders: () => async (dispatch, getState) => {
        console.log('[Outgoing.redux.js] getOutgoingOrders()');
        dispatch(actions.setState({ loading: true }));

        try {
            // QUERY Warehouse.GetOutgoing
            let result = await api.get('/warehouse/shipping');
            console.log(result);
            //console.log(result.outgoingOrders.recordset)
            let _result = result.outgoingOrders.recordset;

            const _arrayResult = [];
            for (let [key, value] of Object.entries(_result)) {
                //console.log(key, value);
                _arrayResult.push(value);
            }
            //console.log(_arrayResult)

            dispatch(actions.setState({
                originalOrders: _arrayResult,
                filteredOrders: _arrayResult,
                filteredSource: _arrayResult,
                loading: false
            }));
        } catch (err) {
            console.log('[Outgoing.redux] catch err')
            console.error(err);
            dispatch(actions.setState({
                originalOrders: [],
                filteredOrders: [],
                filteredSource: [],
                loading: false
            }));
        }
    },


    searchCurrent: ({ searchValue = '', excludeList = [], includeList = [], exactList = [] }) => (dispatch, getState) => {
        console.log('[Outgoing.redux] searchCurrent');

        const finalIncludeList = subtractFields(includeList, excludeList, exactList);
        const finalExactList = exactList.filter(field => !excludeList.includes(field));

        dispatch(actions.setState({ searchLoading: true }));

        setTimeout(() => {
            const { filteredSource, sortOrder, sortField } = getState().warehouseOut;
            let searchedSource = [];

            for (let bp of filteredSource) {
                if (searchValue === '') {
                    searchedSource.push(bp);
                    continue;
                }

                const matchedInclude = matchesIncludeFields(bp, finalIncludeList, searchValue);
                const matchedExact = matchesExactFields(bp, finalExactList, searchValue);

                if (matchedInclude || matchedExact) {
                    searchedSource.push(bp);
                }
            }

            dispatch(actions.setState({
                searchedSource: [...searchedSource],
                searchValue,
                hasFilterBeenApplied: true,
                hasOrder: true,
            }));

            dispatch(actions.sortCurrent({
                field: sortField,
                order: sortOrder
            }));

            dispatch(actions.setState({ searchLoading: false }));
        }, 1000); // 1 second delay
    },

    sortCurrent: ({ field, order }) => (dispatch, getState) => {
        //console.log('[Outgoing.redux] sortCurrent ')
        //console.log(field)
        //console.log(order)
        let { searchedSource, columns } = getState().warehouseOut;

        const numberSortColumns = [
            ...dateColumns,
            'card_code',
        ];

        let newColumns = columns.map((col) => {
            if (col.dataIndex === field) {
                return { ...col, sortOrder: order };
            } else {
                return { ...col, sortOrder: false };
            }
        });

        let outgoingOrders = searchedSource; // IMPORTANT

        if (field !== false) {
            let type = 'string';
            if (numberSortColumns.indexOf(field) !== -1) {
                type = 'number';
            }
            outgoingOrders = searchedSource.sort(makeSorter(type, field));
        }

        if (order === 'ascend') {
            outgoingOrders = outgoingOrders.reverse();
        }

        dispatch(actions.setState({
            columns: newColumns,
            filteredOrders: [...outgoingOrders],
            sortOrder: order,
            sortField: field
        }));
    },

    getOutgoingDetails: (record) => async (dispatch, getState) => {
        console.log('[Outgoing.redux.js] getOutgoingDetails()');
        dispatch(actions.setState({ loading: true }));
        //console.log(state.currentEditRow);
        //console.log(record);
        //console.log(state.currentEditRow.docEntry)

        try {
            // QUERY Warehouse.GetOutgoingLines
            // let result = await api.get(`/warehouse/shipping/details/${state.currentEditRow.docEntry}`, {
            //     params: {
            //         docEntry: state.currentEditRow.docEntry,
            //     },
            // });
            let result = await api.get(`/warehouse/shipping/details/${record.docEntry}`, {
                params: {
                    docEntry: record.docEntry,
                },
            });

            //console.log(result)
            //console.log(result.detailLines.recordset);
            dispatch(actions.setState({ detailLines: result.detailLines.recordset }));
        } catch (err) {
            console.log('[Outgoing.redux] getOutgoingDetails catch err')
            console.error(err);
        }
        dispatch(actions.setState({ loading: false }));
    },

    getDeliveryItemLocations: (itemCode) => async (dispatch) => {
        console.log('[Outgoing.redux] getDeliveryItemLocations');
        //dispatch(actions.setState({ loading: true }));

        console.log(itemCode)
        try {
            let result = await api.get('/warehouse/search-by-item/'
                , { params: { itemCode: itemCode ??  /* DEBUG */'13676' } } // whsCode
            );

            console.log('result');
            console.log(result);

        } catch (err) {
            console.error(err);
        }
    },

    writeDelivery: (currentEditRow, editDetailsLines, popSuccessCB, popWarnEmpty) => async (dispatch, getState) => {
        console.log('[Outgoing.redux.js] writeDelivery()');
        console.log(currentEditRow);
        console.log(editDetailsLines);

        dispatch(actions.setState({ loading: true }));

        let _filtered = editDetailsLines.filter((r) => (r.qtyToDeliver && r.qtyToDeliver > 0)); // hasChanges - someone will inevitably offer default quantities, and we wont know if they meant to submit a line or not

        console.log(_filtered);

        let sendBody = {
            BaseDocEntry: currentEditRow.docEntry,
            DocNum: currentEditRow.docNum,
            BaseDocType: 22, // TODO OR currentEditRow.objType
            CardCode: currentEditRow.cardCode,
            //deliveryShipType: currentEditRow.deliveryShipType,
            //deliveryShipMethod: currentEditRow.deliveryShipMethod,
            trackingNum: currentEditRow.trackingNum, // NOTE original trackNo
            has_split_ship: currentEditRow.has_split_ship,
            trackingNumber: currentEditRow.deliveryTrackNum
        };

        if (_filtered && _filtered.length > 0) {
            sendBody.submitRows = _filtered;
        }

        // TODO_BLANK_NOTES need to prevent writing comments if they are blank, except when they would be intentionally blank
        if (currentEditRow.notes && currentEditRow.notes !== '') {
            sendBody.Comments = currentEditRow.notes;
        }

        // only send deliveryShipMethod and deliveryShipType if they exist
        if (currentEditRow.deliveryShipMethod !== -1 && currentEditRow.deliveryShipType !== -1) {
            sendBody.deliveryShipType = currentEditRow.deliveryShipType;
            sendBody.deliveryShipMethod = currentEditRow.deliveryShipMethod;
        }

        // only send deliveryTrackNum if it exists and is not blank
        if (currentEditRow.deliveryTrackNum && currentEditRow.deliveryTrackNum !== '') {
            sendBody.deliveryTrackNum = currentEditRow.deliveryTrackNum;
        }


        if (!sendBody.submitRows || sendBody.submitRows.length <= 0) {
            console.log('nothing is marked for shipping');
            popWarnEmpty();
            dispatch(actions.setState({ loading: false }));
        } else {
            try {
                let result = await api.put('/warehouse/write-delivery',
                    sendBody);
                console.log('write-deliver restult: ', result);
                console.log(result.data);

                //console.log(result.success);
                if (result.success) {
                    console.log('success');
                    popSuccessCB();
                    dispatch(actions.getOutgoingOrders());
                }

                //console.log(result.errorMsg); // errorMsg: "One of the base documents has already been closed"

            } catch (err) {

                // message: 'One of the base documents has already been closed '

                console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write');
                const errorMsg =
                    err.response?.data?.errorMsg ||
                    err.response?.data?.message ||
                    err.response?.data?.errors?.[0] ||
                    err.message ||
                    'Could not write GRPO';

                message.error(errorMsg);
            }
            dispatch(actions.setState({ loading: false }));

        }
    },
    updateQCNotes: (currentEditRow, popSuccessCB, popFailCB) => async (dispatch, getState) => {
        console.log('[Outgoing.redux.js] updateQCNotes()');
        console.log(currentEditRow);

        dispatch(actions.setState({ loading: true }));

        let sendBody = {
            BaseDocEntry: currentEditRow.docEntry,
            BaseDocType: 22, // TODO OR currentEditRow.objType
            CardCode: currentEditRow.cardCode,
        };

        if (currentEditRow.qcNotes && currentEditRow.qcNotes !== '') {
            sendBody.qcNotes = currentEditRow.qcNotes;
        } else {
            popFailCB();
        }

        //console.log(sendBody);

        try {
            let result = await api.put('/warehouse/write-qc-notes',
                sendBody);
            //console.log(result);
            //console.log(result.data);
            //console.log(result.success);
            if (result.success) {
                console.log('updateQCNotes success');
                setTimeout(() => {
                    popSuccessCB();
                    dispatch(actions.getOutgoingOrders());
                }
                    , 800);
            }

        } catch (err) {
            popFailCB();
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write');
            console.error(err);
        }
        dispatch(actions.setState({ loading: false }));
    },
    updateQCStatus: (currentEditRow, popSuccessCB, popFailCB) => async (dispatch, getState) => {
        console.log('[Outgoing.redux.js] updateQCStatus()');
        //console.log(currentEditRow);
        console.log(currentEditRow.qcStatus);
        dispatch(actions.setState({ loading: true }));

        let sendBody = {
            BaseDocEntry: currentEditRow.docEntry,
            BaseDocType: 22, // TODO OR currentEditRow.objType
            CardCode: currentEditRow.cardCode,
        };

        if (currentEditRow.qcStatus && currentEditRow.qcStatus !== '') {
            sendBody.qcStatus = currentEditRow.qcStatus;
        }

        //console.log(sendBody);

        try {
            let result = await api.put('/warehouse/write-qc-status',
                sendBody);
            //console.log(result);
            //console.log(result.data);
            //console.log(result.success);
            if (result.success) {
                console.log('updateQCStatus success');
                setTimeout(() => {
                    popSuccessCB();
                    dispatch(actions.getOutgoingOrders());
                }
                    , 800);
            }

        } catch (err) {
            popFailCB();
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write');
            console.error(err);
            const errorMsg =
                    err.response?.data?.errorMsg ||
                    err.response?.data?.message ||
                    err.response?.data?.errors?.[0] ||
                    err.message ||
                    'Could not update QC status';

                message.error(errorMsg);
        }
        dispatch(actions.setState({ loading: false }));
    },

    // getAttachments: (atc) => async (dispatch, getState) => {
    //     console.log('getAttachments');
    //     // console.log(atc);
    //     // console.log(atc.allAtcEntry);
    //     // console.log(atc.filteredAtcEntry);

    //     dispatch(actions.setState({
    //         loading: true,
    //         picturesLoading: true,
    //     }));

    //     let atc_entry = atc.filteredAtcEntry;

    //     // QUERY Orders.GetAttachments
    //     let atcData = await api.get(`/warehouse/artwork/get-attachments/${atc_entry}`, {
    //         params: {
    //             atcEntry: atc_entry,
    //         },
    //     });

    //     //console.log(atcData);
    //     console.log(atcData.attachments);
    //     console.log(atcData.errors);

    //     // console.log(atcData.data)
    //     // console.log(atcData.data.attachments)
    //     // console.log(atcData.data.msgAttachments)
    //     // console.log(atcData.data.msgObjects)
    //     dispatch(actions.setState({
    //         loading: false,
    //         picturesLoading: false,
    //         modalOpen: true,
    //         pictureAttachments: atcData.attachments,
    //         msgAttachments: atcData.msgAttachments, 	// base64
    //         msgObjects: atcData.msgObjects, 			// text information in objects
    //         attachmentErrors: atcData.errors
    //     }));
    // },

    getWarehouseLocations: () => async (dispatch, getState) => {
        console.log('[Outgoing.redux.js] getWarehouseLocations()');
        //dispatch(actions.setState({ loading: true }));

        try {
            // QUERY Transfer.GetWarehouses + Transfer.AllLocations
            let result = await api.get('/warehouse/all-locations/'
                // , { params: { search: _search } }
            );
            console.log(result)
            dispatch(actions.setState({
                warehouseRows: result.warehouses,
                locationRows: result.locations,
                //loading: false
            }));
        } catch (err) {
            console.log('[Outgoing.redux] catch err')
            console.error(err);
            dispatch(actions.setState({
                warehouseRows: [],
                locationRows: [],
                //loading: false
            }));
        }
    },

    searchInventory: (search) => async (dispatch, getState) => {
        console.log('[Outgoing.redux.js] getItems() : search', search);

        const state = getState();
        dispatch(actions.setState({ loading: true, inventorySearchLoading: true }));

        try {

            let _search = '%' + search + '%';

            // QUERY Transfer.GetTransferItems
            let exactResults = await api.get('/warehouse/item-transfers/'
                , { params: { search: search } } // not using % wildcards for exact
            );
            console.log(exactResults)

            // QUERY Transfer.GetTransferItemsSearch
            let result = await api.get('/warehouse/item-transfers-search/'
                , { params: { search: _search } }// using % wildcards for search
            );
            console.log(result)
            let exactItems = exactResults.items || [];
            let searchItems = result.items || [];

            if (!exactItems.length && !searchItems.length) {
                message.warning('No transfer items found.');
            } else {
                if (!exactItems.length) {
                    message.warning('No exact item match found.');
                }

                if (!searchItems.length) {
                    message.warning('No related transfer items found.');
                }
            }

            dispatch(actions.setState({
                inventoryResultsExact: exactItems,
                inventoryResults: searchItems,
            }));

            // give a slight delay before loading false because it feels jarring
            setTimeout(() => {
                dispatch(actions.setState({
                    loading: false,
                    inventorySearchLoading: false
                }));
            }
                , 500);

        } catch (err) {
            console.log('[Outgoing.redux] catch err')
            console.error(err);
            dispatch(actions.setState({
                inventoryResults: [],
                inventoryResultsExact: [],
                loading: false,
                inventorySearchLoading: false
            }));
        }
    },

};
